/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import ApiClientBase from '@/services/api-client.base';
import {
  DriverExportToPdfProofOfIncomeCommand,
  DriverExportToPdfRequestForPaymentCommand,
  DriverMassExportToPdfRequestForPaymentCommand,
  DriversExportToPdfPostOfficeBookCommand,
  DriverExportToPdfRequestForPaymentCommand,
  DriversExportToPdfPayoffsSummaryCommand,
  DriversExportToPdfPostOfficeBookCommand,
  ExportSettlementFileTypeEnum,
  ExportSettlementToFileForPaymentCommandRequest,
  FileTypeEnum,
  ExportToPdfPaymentsSummaryForTaxCommand,
  MediaCreateCommandResult, HrStatusEnum,
  ExportAllVehiclesToCsvCommand, ExportDriversCommand, ExportPayoffsCommand, ExportDebtorsToCsvCommand,
  ExportVehiclePaidRentCommand, ExportUserWithdrawSummaryCommand, ExportSettlementsDetailedCommand, ExportWorkLogsCommand,
  ExportTakenCashFromSettlementsCommand
} from '@/services/api-clients';
import {AxiosError, AxiosRequestConfig, AxiosResponse, CancelToken,} from 'axios';
import i18n from '@/i18n/config';
import {LF} from '@/i18n/LF'

export class MediaService extends ApiClientBase {
  downloadFile(id: number, cancelToken?: CancelToken | undefined): Promise<Blob> {
    let url_ = `${this.baseUrl}/Media/Download/${id}`;
    url_ = url_.replace(/[?&]$/, '');

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      responseType: 'blob',
      cancelToken,
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if(_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return _response.data
    });
  }

  downloadMail(id: number , cancelToken?: CancelToken | undefined): Promise<Blob> {
    let url_ = `${this.baseUrl}/Mails/Download/${id}`;
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace(/[?&]$/, '');

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      responseType: 'blob',
      cancelToken,
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if(_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return _response.data
    });
  }


  sendFile(file: File, fileTypeId?: FileTypeEnum | null, isMobileAppVisible?: boolean, cancelToken?: CancelToken | undefined): Promise<MediaCreateCommandResult> {
    let url_ = `${this.baseUrl}/Media`;
    url_ = url_.replace(/[?&]$/, '');

    const formData = new FormData();
    formData.append('file', file);
    if (fileTypeId !== undefined && fileTypeId !== null) {
      formData.append('fileTypeId', String(fileTypeId));
    }
    if (isMobileAppVisible !== undefined) {
      formData.append('isMobileAppVisible', String(isMobileAppVisible));
    }

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const options_ = <AxiosRequestConfig>{
      method: 'POST',
      url: url_,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      const _responseText = _response.data;
      let result200: any = null;
      const resultData200 = _responseText;
      try {
        result200 = JSON.parse(resultData200);
      } catch (e) {
        result200 = resultData200;
      }
      return result200;
    });
  }

  massExportSettlementsToFileType(ids: number[], fileType: ExportSettlementFileTypeEnum, cancelToken?: CancelToken | undefined): Promise<Blob> {
    let url_ = `${this.baseUrl}/Settlements/MassExportSettlements`;
    url_ = url_.replace(/[?&]$/, '');

    const request: ExportSettlementToFileForPaymentCommandRequest = {
      settlementIds: ids,
      targetFileType: fileType,
    }

    const options = {
      method: 'POST',
      url: url_,
      data: request,
      cancelToken,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if(_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      if (fileType === ExportSettlementFileTypeEnum.Csv) {
        return new Blob([_response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      }
      return new Blob([_response.data], { type: 'text/plain' });
    });
  }

  massExportOptima(ids: number[], cancelToken?: CancelToken | undefined): Promise<Blob> {
    let url_ = '/Drivers/ExportDataToExcelFile';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: ids,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return new Blob([_response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
    });
  }

  exportDriverToPdf(id: number, cancelToken?: CancelToken | undefined): Promise<Blob> {
    let url_ = `/Drivers/ExportDriverDataToPdfFile/${id}`;
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'GET',
      url: url_,
      responseType: 'blob',
      cancelToken,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return new Blob([_response.data], {type: 'application/Pdf'})
    });
  }

  exportSettlementToPdf(id: number, cancelToken?: CancelToken | undefined): Promise<Blob> {
    let url_ = `/Settlements/ExportSettlementToPdf/${id}`;
    url_ = url_.replace(/[?&]$/, '');
    const options = {
      method: 'GET',
      url: url_,
      responseType: 'blob',
      cancelToken,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return new Blob([_response.data], {type: 'application/Pdf'})
    });
  }

  exportPdfRequestForPayment(request: DriverExportToPdfRequestForPaymentCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string, mediumId: number}> {
    let url_ = '/Drivers/ExportToPdfDriverRequestForPayment';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
        mediumId: Number.parseInt(decodeURIComponent(escape(atob(_response.headers['mediumid']))))
      }
    });
  }

  exportPdfProofOfIncome(request: DriverExportToPdfProofOfIncomeCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string, mediumId: number}> {
    let url_ = '/Drivers/ExportToPdfDriverProofOfIncome';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
        mediumId: Number.parseInt(decodeURIComponent(escape(atob(_response.headers['mediumid']))))
      }
    });
  }

  exportPdfEquipmentReturnRequest(request: DriverExportToPdfProofOfIncomeCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string, mediumId: number}> {
    let url_ = '/Drivers/ExportToPdfEquipmentReturnRequest';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
        mediumId: Number.parseInt(decodeURIComponent(escape(atob(_response.headers['mediumid']))))
      }
    });
  }

  exportPdfPostOfficeBook(request: DriversExportToPdfPostOfficeBookCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string, mediumId: number}> {
    let url_ = '/Drivers/ExportToPdfPostOfficeBook';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
        mediumId: Number.parseInt(decodeURIComponent(escape(atob(_response.headers['mediumid']))))
      }
    });
  }

  exportToPdfPaymentsSummaryForTax(request: ExportToPdfPaymentsSummaryForTaxCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string, mediumId: number}> {
    let url_ = '/Drivers/ExportToPdfPaymentsSummaryForTax';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
        mediumId: Number.parseInt(decodeURIComponent(escape(atob(_response.headers['mediumid']))))
      }
    });
  }

  exportToPdfInvoice(request: number, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string, mediumId: number}> {
    let url_ = '/Settlements/CreateInvoice';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      params: { id: request },
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
        mediumId: Number.parseInt(decodeURIComponent(escape(atob(_response.headers['mediumid']))))
      }
    });
  }

  downloadSelectedInvoiceToZip(ids: number[], cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let params = ''
    ids.forEach((id) => {
      params += `ids=${id}&`;
    });

    let url_ = `/Invoices/DownloadSelected?${params}`;
    url_ = url_.replace(/[?&]$/, '');


    const options = {
      method: 'GET',
      url: url_,
      responseType: 'blob',
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  massExportDriverRequestForPaymentToZip(request: DriverMassExportToPdfRequestForPaymentCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = `/Drivers/MassExportRequestForPayment`;
    url_ = url_.replace(/[?&]$/, '');


    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  exportToPdfPayoffsSummary(request: DriversExportToPdfPayoffsSummaryCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string, mediumId: number}> {
    let url_ = '/Drivers/ExportToPdfPayoffsSummary';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
        mediumId: Number.parseInt(decodeURIComponent(escape(atob(_response.headers['mediumid']))))
      }
    });
  }

  async massCreateInvoices(ids: number[]): Promise<{file: Blob, fileName:string}> {
    let url_ = `/Settlements/MassCreateInvoice`;
    url_ = url_.replace(/[?&]$/, '');


    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: ids
    } as AxiosRequestConfig;

    return await this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then(async (_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 400) {
          const error = await _response.data.text() as string;

          throw [error];
        }

        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  previewDigitalDocumentFile(id: number): Promise<{file: Blob, fileName: string}> {
    let url_ = '/DigitalDocuments/ViewFile';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      params: { id },
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  downloadHrTagLegend(  cancelToken?: CancelToken | undefined): Promise<Blob> {
       let url_ = this.baseUrl + "/Drivers/DownloadHrTagLegend";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "POST",
      url: url_,
      responseType: 'blob',
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return new Blob([_response.data], {type: 'application/Pdf'})
    });
  }

  exportForHrStatusVerification(hrStatus?: HrStatusEnum): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Drivers/ExportForHrStatusVerification';
    url_ = url_.replace(/[?&]$/, '');
    const params = new URLSearchParams([['status', hrStatus]]);

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      params: { status: hrStatus },
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw _response.data;
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  exportAllDriversDataToExcelFile(status: HrStatusEnum): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Drivers/ExportAllDriversDataToExcelFile';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      params: {
        status
      }
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  exportVehiclesToCsv(request: ExportAllVehiclesToCsvCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Vehicles/ExportVehiclesToCsv';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        throw [i18n.t(LF.UnableToDownloadFile) as string];
      }

      // Sprawdzamy, czy odpowiedź zawiera dane binarne czy JSON (w przypadku błędu biznesowego)
      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        // Jeżeli to JSON to mamy doczynienia z błędem biznesowym, konwertujemy Blob na tekst, a następnie parsujemy jako JSON
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      // W przypadku odpowiedzi z danymi binarnymi zwracamy plik i nazwę
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  exportDriversToCsv(request: ExportDriversCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Drivers/ExportDriversToCsv';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }

      }

      // Sprawdzamy, czy odpowiedź zawiera dane binarne czy JSON (w przypadku błędu biznesowego)
      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        // Jeżeli to JSON to mamy doczynienia z błędem biznesowym, konwertujemy Blob na tekst, a następnie parsujemy jako JSON
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      // W przypadku odpowiedzi z danymi binarnymi zwracamy plik i nazwę
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  exportPayoffsToCsv(request: ExportPayoffsCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Payoff/Export';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }

      }

      // Sprawdzamy, czy odpowiedź zawiera dane binarne czy JSON (w przypadku błędu biznesowego)
      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        // Jeżeli to JSON to mamy doczynienia z błędem biznesowym, konwertujemy Blob na tekst, a następnie parsujemy jako JSON
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      // W przypadku odpowiedzi z danymi binarnymi zwracamy plik i nazwę
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  exportDebtorsToCsv(request: ExportDebtorsToCsvCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Drivers/ExportDebtors';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }

      }

      // Sprawdzamy, czy odpowiedź zawiera dane binarne czy JSON (w przypadku błędu biznesowego)
      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        // Jeżeli to JSON to mamy doczynienia z błędem biznesowym, konwertujemy Blob na tekst, a następnie parsujemy jako JSON
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      // W przypadku odpowiedzi z danymi binarnymi zwracamy plik i nazwę
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });

  }

  exportVehiclePaidRentToCsv(request: ExportVehiclePaidRentCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Vehicles/ExportVehiclePaidRent';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }

      }

      // Sprawdzamy, czy odpowiedź zawiera dane binarne czy JSON (w przypadku błędu biznesowego)
      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        // Jeżeli to JSON to mamy doczynienia z błędem biznesowym, konwertujemy Blob na tekst, a następnie parsujemy jako JSON
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      // W przypadku odpowiedzi z danymi binarnymi zwracamy plik i nazwę
      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });

  }

  exportWorkLogToCsv(request: ExportWorkLogsCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/WorkLogs/ExportWorkLogs';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {
        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }
      }

      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);
          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });
  }

  exportSettlementsDetailedToCsv(request: ExportSettlementsDetailedCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Settlements/ExportDetailed';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }

      }

      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });

  }

  exportTakenCashFromSettlementsToCsv(request: ExportTakenCashFromSettlementsCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Settlements/ExportTakenCash';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }

      }

      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });

  }

  exportWithdrawSummary(request: ExportUserWithdrawSummaryCommand, cancelToken?: CancelToken | undefined): Promise<{file: Blob, fileName: string}> {
    let url_ = '/Users/ExportWithdrawSummary';
    url_ = url_.replace(/[?&]$/, '');

    const options = {
      method: 'POST',
      url: url_,
      responseType: 'blob',
      data: request,
      cancelToken
    } as AxiosRequestConfig;

    return this.instance.request(options).catch((_error: any) => {
      if (this.isAxiosError(_error) && _error.response) {
        return _error.response;
      }
      throw _error;
    }).then((_response: AxiosResponse) => {
      if (_response.status >= 400) {

        if (_response.status === 403) {
          throw [i18n.t(LF.NoAccess) as string];
        } else {
          throw [i18n.t(LF.UnableToDownloadFile) as string];
        }

      }

      if (_response.headers['content-type'] && _response.headers['content-type'].includes('application/json')) {
        return _response.data.text().then((text: string) => {
          const result = JSON.parse(text);

          throw result.errors || [i18n.t(LF.UnableToDownloadFile) as string];
        });
      }

      return {
        file: _response.data,
        fileName: decodeURIComponent(escape(atob(_response.headers['filename']))),
      }
    });

  }

  private isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
  }
}
